module.exports = __webpack_public_path__ + "img/hamburg.8a808fc.webp";